module.exports = __webpack_public_path__ + "img/230f174a00e032b855fd411e1d95bd1a.png";